import { render, staticRenderFns } from "./studiolist.vue?vue&type=template&id=c2cef11a&scoped=true&"
import script from "./studiolist.vue?vue&type=script&lang=js&"
export * from "./studiolist.vue?vue&type=script&lang=js&"
import style0 from "./studiolist.vue?vue&type=style&index=0&id=c2cef11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cef11a",
  null
  
)

export default component.exports